module.exports = __webpack_public_path__ + "static/media/tlyfepro.2093bb66.png";